<template>
  <div style="height:400px"> 
      <welcome/> 
  <div v-if="isUnsubscribed==null" style="margin-top:50px">
    <div class="alert alert-info">
    <strong>Info!</strong> Unsubscribing, please wait....
    </div>

  </div>
  <div v-else-if="isUnsubscribed==false" style="margin-top:50px">
      <div class="alert alert-danger">
      <strong>Warning!</strong> Email unsubscribe failed. Please contact our support team from more detail.
      </div>
   </div>
    <div v-else style="margin-top:50px">
      <div class="alert alert-success">
       Email unsubscribed successfully. 
      </div>
   </div>
  </div>
</template>
<script>

import Vue from 'vue'
import welcome from '../../shared/Welcome.vue'
import authservice from "../../services/authservice";
export default {
  name: "unsubscribe",
  components : {
    welcome
  },  

  beforeRouteEnter(to, from, next) {
 
    var promises = [authservice.emailUnsubscribe(to.query.code)];

     Promise.all(promises).then(response => {
          next(p => {
           p.isUnsubscribed = response[0].body;
          });
        });
  },
  data(){
    return {
      isUnsubscribed: null
    }
  }
}
</script>

